import {initTitleAnimation} from "../components/titleAnimation";

export function initInformationPageLanding() {

    initTitleAnimation();
}
